export default __webpack_public_path__ + "static/loading_product_icon_cloth-a5bf47f99b45a1cd8f210f44ac5d96e9.png";